import React from "react";
import { ReactNode } from "react";
import { TextProps, TitleProps } from "@mantine/core";
import { Text as MantineText, Title } from "@mantine/core";
import classes from "./Text.module.css";

export type TextVariant =
  | "h1"
  | "h2"
  | "h3"
  | "h4"
  | "h5"
  | "reading"
  | "reading_bold"
  | "reading_medium"
  | "reading_list"
  | "reading_medium_bold"
  | "reading_small"
  | "reading_small_bold"
  | "subheadline_bold";

interface Props {
  variant: TextVariant;
  color?: string;
  children: ReactNode;
}

const Text: React.FC<Props & TextProps & TitleProps> = ({ variant, className, color, ...rest }) => {
  const variantClass = [classes[variant], className].filter(Boolean).join(" ");

  switch (variant) {
    case "h1":
    case "h2":
    case "h3":
    case "h4":
      return <Title fw={900} lts={0} className={variantClass} {...rest} />;
    case "h5":
      return <Title fw={700} lts={0} className={variantClass} {...rest} />;
    case "reading_bold":
    case "reading_medium_bold":
    case "reading_small_bold":
    case "subheadline_bold":
      return <MantineText fw={700} lts={0} className={variantClass} c={color ?? "var(--mantine-color-neutral-9)"} {...rest} />;
    case "reading":
    case "reading_medium":
    case "reading_list":
    case "reading_small":
    default:
      return <MantineText fw={400} lts={0} className={variantClass} c={color ?? "var(--mantine-color-neutral-9)"} {...rest} />;
  }
};

export default Text;
